import { CartErrorsEnum } from '@src/domains/cart';
import type { ProductAdderStep } from '@src/domains/products/features/productAdder/types/productAdder';

export function hasTariffVerificationError(errors: Record<string, CartErrorsEnum> | undefined): boolean {
  if (!errors) return false;
  return Object.values(errors).some((value) => value === CartErrorsEnum.TARIFF_VERIFICATION_VALIDATION_NOT_FULFILLED);
}

export function shouldGoBackToTariffStep(
  currentStep: ProductAdderStep | undefined,
  errors: Record<string, CartErrorsEnum> | undefined,
): boolean {
  if (currentStep !== 'finish') return false;
  return hasTariffVerificationError(errors);
}
